export const screenSizes = {
  mobile: '(max-width: 767px)',
  tablet: '(max-width: 1500px)',
};
